import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';


@customElement('shared-specsheet-head')
export class SharedSpecsheetHead extends connect(store)(LitElement) {

	static styles = [
	css`

		:host {
			margin: var(--specsheet-medium-gap) var(--specsheet-large-gap) 0 var(--specsheet-large-gap);
		}

		.headline {
			display: flex;
			width: 100%;
			justify-content: space-between;
		}

		.title {
			margin: 0;
		}

		.subtitle {
			color: var(--color-black);
			text-decoration: none;
			font: var(--font-specsheet-print-light);
			margin: 0;
			text-transform: uppercase;
		}

		.document-subtitle {
			font: var(--font-summary-paragraph);
		}

		a {
			color: var(--color-black);
			text-decoration: none;
		}

		@media print {
			:host {
				padding-bottom: var(--specsheet-small-gap);
				margin: 0;
			}

			.headline {
				display: flex;
				width: 100vw;
				justify-content: space-between;
				box-sizing: border-box;
				margin: 0;
			}

			.document-subtitle {
				font: var(--font-specsheet-print-light);
				color: var(--color-grey4);
				flex: 1;
				text-align: right;
			}

			.title {
				font: var(--font-modal-title);
				color: var(--color-black);
				margin: 0;
				line-height: 1.2;
				letter-spacing: 1px;
				flex: 2;
			}

			h2.title {
				font: var(--font-specsheet-print-title-bold);
				padding-bottom: var(--specsheet-print-small-gap);
			}

			.subtitle {
				color: var(--color-black);
				text-decoration: none;
				font: var(--font-specsheet-print-light);
				margin: 0;
				text-transform: uppercase;
			}
		}
	`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}


	stateChanged(state) {
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.shortArticleNumber = state.shortArticleNumber.data;
		this.status = state.status;
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
		if (state.specsheet.data.specsheets && state.status.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
	}


	render() {
		return html`
			<div class="headline">

				<div class="flex-item title">
					<h2 class="title">
						${this.family}
					</h2>
					<h3 class="subtitle">
						${when(
							this.shortNumberProductModel !== '',
							() => html`<a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.status.mode}/${this.status.shortKey}">${this.shortNumberProductModel}</a>`,
							() => html``
						)}
					</h3>
				</div>

				<div class="flex-item document-subtitle">
					${msg('Specsheet')}
				</div>
			</div>
        `;
	}
}
